/* =========================================================
   Blog BETA — multi-language video switcher.
   The post body (rendered from Shopify article.content) contains a .ml-video
   block with a <video data-ml-srcs="[urls]" data-ml-posters="[posters]"> and
   .ml-lang buttons (data-ml-i). Runs on BOTH the beta feed and the individual
   article page (document-delegated).

   Behaviour:
   - Each language keeps its OWN playback position.
   - Switching always PAUSES (never autoplays); user presses play.
   - Switching back restores the other language at its remembered position.
   - Poster: each language uses its OWN poster (data-ml-posters[i]) and only at
     the start — when resuming mid-video the poster is dropped so the thumbnail
     doesn't flash over the frame.
   ========================================================= */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var lang = e.target.closest && e.target.closest(".ml-lang");
    if (!lang) return;
    var box = lang.closest(".ml-video");
    var vid = box && box.querySelector("video");
    if (!vid) return;

    var srcs, posters;
    try { srcs = JSON.parse(vid.getAttribute("data-ml-srcs") || "[]"); } catch (err) { srcs = []; }
    try { posters = JSON.parse(vid.getAttribute("data-ml-posters") || "[]"); } catch (err) { posters = []; }
    var target = parseInt(lang.getAttribute("data-ml-i"), 10) || 0;
    if (!srcs[target]) return;

    // Per-video state: remembered position per source index + current index.
    if (!vid._mlPos) vid._mlPos = {};
    var cur = vid._mlCur;
    if (cur == null) {
      cur = 0;
      for (var k = 0; k < srcs.length; k++) { if (srcs[k] === vid.currentSrc) { cur = k; break; } }
      vid._mlCur = cur;
    }

    box.querySelectorAll(".ml-lang").forEach(function (b) { b.classList.remove("is-active"); });
    lang.classList.add("is-active");
    if (target === cur) return; // already showing this language

    // Remember where the current language is, pause it, then swap.
    vid._mlPos[cur] = vid.currentTime || 0;
    vid.pause();
    vid._mlCur = target;
    var pos = vid._mlPos[target] || 0;

    var tp = posters[target] || "";

    if (pos > 0) {
      // Resume mid-video: fetch + seek to the frame; never show the poster
      // (otherwise the thumbnail flashes over the resumed position).
      vid.removeAttribute("poster");
      vid.preload = "auto";
      vid.setAttribute("src", srcs[target]);
      vid.load();
      var onReady = function () {
        vid.removeEventListener("loadedmetadata", onReady);
        try { vid.currentTime = pos; } catch (e2) {}
        // intentionally NOT playing — the new language starts paused.
      };
      vid.addEventListener("loadedmetadata", onReady);
    } else {
      // At the start: show THIS language's poster. Mirror the editor — set src +
      // poster and DO NOT call load(); the src change resets the element so the
      // poster displays (an explicit load() fetches a frame that hides it).
      vid.setAttribute("src", srcs[target]);
      if (tp) vid.setAttribute("poster", tp); else vid.removeAttribute("poster");
    }
  });
})();
